import React, { lazy } from "react";

/**
 * React.lazy + bọc theme antd: tải file của trang và theme antd SONG SONG.
 * Nhờ vậy antd (ConfigProvider + cssinjs) không nằm trong JS chính mà mọi trang phải tải trước khi hiện.
 */
const themedLazy = (load) =>
  lazy(() =>
    Promise.all([load(), import("../antdTheme")]).then(([mod, themeMod]) => {
      const Page = mod.default;
      const Theme = themeMod.default;
      const Themed = (props) => (
        <Theme>
          <Page {...props} />
        </Theme>
      );
      return { default: Themed };
    })
  );

export default themedLazy;
